import select from './select.vue'

export default select
